import { BaseGridDocumentComponent } from '@dato-pages/base/base-grid-document-component';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { Component, Input } from '@angular/core';
import { Ledger } from '@dato-proxy/entities/ledger.entity';

@Component({
    providers: ServiceBagServices,
    selector: 'app-ledger-grid',
    templateUrl: './ledger-grid.component.html',
    styleUrls: ['./ledger-grid.component.scss']
})
export class LedgerGridComponent extends BaseGridDocumentComponent<Ledger> {

    @Input() IsOpen: boolean;
    KeyExpr = ["EntryID", "LineID"];

    constructor(A: ServiceBagService) {
        super(A, 'LedgerGridComponent', Ledger);
    }

    OnRowPrepared(e) {
        // Hide row if it is 'Opening balance' row and opening balance equal 0
        if (e.data && e.data.EntryID === 0 && e.data.OpenBalance === 0) {
            e.rowElement.style.display = 'none';
        }
    }
}
